import React from 'react';

import {DialogProps} from '@material-ui/core/Dialog';
import {DialogContent} from '@material-ui/core';
import CustomDialog from '../CustomDialog';
import Button from '../Button';
import paymentSuccessImg from '../../assets/image/payment-result-success.jpg';
import paymentFailedImg from '../../assets/image/payment-result-failed.jpg';

import {useTranslation} from 'react-i18next';

import styles from './DialogCodResult.module.css';


type DialogType = 'success' | 'failed';
export type DialogTypeContent = {
  [x in DialogType]: {
    img: string,
    content: string
    subContent: string
  }
}

interface DialogCodResultProps extends DialogProps {
  type: DialogType
  message: string

  onClose: () => void
  onConfirm: () => void
}

const dialogTypeContent: DialogTypeContent = {
  success: {
    img: paymentSuccessImg,
    content: 'yourPaymentIsSuccessful',
    subContent: 'enjoyLearningManabie'
  },
  failed: {
    img: paymentFailedImg,
    content: 'yourPaymentIsFailed',
    subContent: 'pleaseTryAgain'
  }
};


const DialogCodResult = (props: DialogCodResultProps) => {
  const {t} = useTranslation();

  const {onConfirm, type, message, ...rest} = props;
  const contents = dialogTypeContent[type];

  return (
    <CustomDialog {...rest} >
      <DialogContent classes={{root: styles.content}}>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <img
            className={styles.img}
            src={contents.img}
            alt="payment result"
          />
          <div className={styles.contentWrapper}>
            <div className={styles.mainContent}>{t(contents.content)}</div>
            <div className={styles.errorContent}>{message}</div>
            <div className={styles.subContent}>{t(contents.subContent)}</div>
            <Button className={styles.button} onClick={onConfirm}>
              {t(type === 'success' ? 'goToSummary' : 'back')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </CustomDialog>
  );
};

export default DialogCodResult;